import Echo from "laravel-echo";
import AppConfig from "@/config";
import { AuthHttpService } from "@/api/http/AuthHttpService";

/**
 * Websocket connection singleton
 * @returns Connection instance
 */
class WebsocketConnection {
  private static echoInstance: Echo | null = null;
  static STATE_CONNECTED = "connected" as const;

  private constructor() {}

  static get instance(): Echo {
    if (!this.echoInstance) {
      this.echoInstance = new Echo({
        activityTimeout: 10_000,
        broadcaster: "pusher",
        cluster: AppConfig.wsCluster,
        disableStats: true,
        encrypted: true,
        forceTLS: AppConfig.isHttps,
        key: AppConfig.wsKey,
        pongTimeout: 10_000,
        wsHost: AppConfig.wsHost,
        wssHost: AppConfig.wsHost,
        wsPort: AppConfig.wsPort,
        wssPort: AppConfig.wsPort,
        authorizer: ({ name }: { name: string }) => ({
          authorize: async (socket_id: string, callback: (bool: boolean, data: string) => void) => {
            try {
              const data = await new AuthHttpService().authorizeBroadcast({
                socket_id,
                channel_name: name,
              });
              callback(false, data);
            } catch (error) {
              callback(true, error as string);
            }
          },
        }),
      });
    }
    return this.echoInstance;
  }

  static get isConnected() {
    return this.echoInstance?.connector.pusher.connection.state === this.STATE_CONNECTED;
  }
}

export default WebsocketConnection;
